<div class="dialog-wrapper">
    <header class="dialog-header">
      <h3 class="header-heading">{{ 'pages.userFamily.forceAccept.heading' | translate }}</h3>
      <button mat-icon-button class="close-button" [attr.aria-label]="'common.close' | translate" [disabled]="processingSubmit" (click)="closeDialog()">
        <span class="icon-close"></span>
      </button>
    </header>

    <div class="dialog-content">

      <div class="family-member">
        <img class="user-avatar" *ngIf="!data.link.userId.picture" src="https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png" alt="">
        <img class="user-avatar" *ngIf="data.link.userId.picture" [src]="data.link.userId.picture" alt="">
        <div class="row">
            <div class="col">
              <div class="row name">
                <div>{{ data.link.userId.firstName }} {{ data.link.userId.lastName }}</div>
              </div>
              <div *ngIf="data.link.link" class="row link">
                <div>
                    <span>{{ linkLabel }}</span>
                </div>
              </div>
            </div>
        </div>
      </div>

      <p class="not-accepted-warning">
        <span class="icon-warning"></span>
        <span *ngIf="data.link.isSource">{{ 'pages.userFamily.invitationNotAccepted' | translate: { name: data.link.userId.firstName } }}</span>
        <span *ngIf="!data.link.isSource">{{ 'pages.userFamily.invitationNotAcceptedByCitizen' | translate: { name: data.link.userId.firstName } }}</span>
      </p>

      <p class="force-accept-instructions">
        {{ 'pages.userFamily.forceAccept.instructions' | translate }}
      </p>

    </div>

    <footer class="dialog-footer">
      <div class="inline-button-wrap">
        <button
          class="bciti-inline-button"
          [disabled]="processingSubmit"
          (click)="closeDialog()"
        >{{ 'pages.userFamily.button.cancel' | translate }}</button>
      </div>

      <button
        class="bciti-button"
        [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'"
        [disabled]="processingSubmit"
        (click)="submit()"
      >
        <span *ngIf="!processingSubmit">{{ 'pages.userFamily.button.force-accept' | translate }}</span>
        <mat-spinner diameter="20" *ngIf="processingSubmit"></mat-spinner>
      </button>
    </footer>
  </div>
